import * as React from "react";
import { withTheme } from "styled-components";
import type { RuntimeTheme } from "../../../lib/theme/theme";
import type { RenderEnvironment } from "common/components/types";
import AuthController from "../../../chrome/smart/auth-controller/auth-controller";
import { AppAuthenticationKind } from "common/components/SerializedApp";
import { getLastKnownAppLogin } from "webapp/app-login";

interface Props {
    theme: RuntimeTheme;
    env: RenderEnvironment;
    onSuccess: (() => void) | undefined;
    onAbort: (() => void) | undefined;
}

class EmbeddedAuthScreen extends React.PureComponent<Props> {
    public render(): React.ReactNode {
        const { env, theme, onSuccess } = this.props;

        const login = getLastKnownAppLogin();
        return (
            <AuthController
                appID={env.appEnvironment.appID}
                authKind={AppAuthenticationKind.EmailPin}
                withBranding={false}
                accentColor={login?.theme.primaryAccentColor ?? theme.primaryAccentColor}
                appFeatures={env.appEnvironment.appFeatures}
                onLoggedIn={onSuccess !== undefined ? async () => onSuccess() : undefined}
                previewMode={false}
            />
        );
    }
}

export default withTheme(EmbeddedAuthScreen);
